import { createFileRoute } from "@tanstack/react-router";
import { TastingList } from "@/features/food-sensory/tasting-list";

export const Route = createFileRoute("/food-app/tastings/")({
  component: TastingsPage,
});

function TastingsPage() {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h1 className="text-base font-semibold">Tastings</h1>
        <p className="text-sm text-muted-foreground">
          Tastings of food application products, one product after another, run live or self-paced.
        </p>
      </div>
      <TastingList />
    </div>
  );
}
